import styled from 'styled-components'
import { greys } from 'assets/themes/theme-default'
import { isMobile } from 'react-device-detect'

const GalleryWrapper = styled.div`
  background: ${greys.light3};
  max-width: 90%;
  margin: 0 auto;
  padding: ${isMobile ? '12px 0' : '0'};
  .image-gallery .image-gallery-swipe .image-gallery-slides {
    left: 0;
    width: 100%;
    border-radius: 2px;
  }

  .image-gallery .image-gallery-fullscreen-button {
    right: 0;
    bottom: 0;
    z-index: 2;
  }

  .image-gallery-bullets .image-gallery-bullet {
    border: 0;
    background-color: ${greys.dark3};
    box-shadow: none;
  }

  .image-gallery-bullets .image-gallery-bullet.active {
    background-color: ${props => props.theme.colors.color1.bg};
  }

  .image-gallery-left-nav,
  .image-gallery-right-nav {
    height: 100%;
    z-index: 1;
    padding: 0 1rem;
  }

  .image-gallery-left-nav:hover,
  .image-gallery-right-nav:hover {
    transition: 0.2s;
  }

  .image-gallery-left-nav:hover:before,
  .image-gallery-right-nav:hover:before {
    transition: 0.2s;
    color: ${greys.dark1};
  }
`

export default GalleryWrapper
